export function setupModalBackgroundWidthHandling(): void {
    window.addEventListener('resize', adjustModalBackgroundWidth);

    observeModalBackdropCreation();
}

function adjustModalBackgroundWidth() {
    const modalBackdrop = document.querySelector('#no-jquery-ui > div.modal-backdrop') as HTMLElement;
    if (modalBackdrop) {
        const modalPopups = getModalPopups();

        const adminSidebar = document.querySelector('.admin-sidebar') as HTMLElement;

        modalBackdrop.style.left = adminSidebar.offsetWidth + 'px';
        modalPopups.forEach((modalPopup: HTMLElement) => {
            modalPopup.style.left = adminSidebar.offsetWidth + 'px';
        });
    }
}

function getModalPopups() {
    const selectRootModals = '#no-jquery-ui > div.modal';
    const selectNestedModals = '#no-jquery-ui > div.modal-container > div.modal';

    return document.querySelectorAll([selectRootModals, selectNestedModals].join(', '));
}

function observeModalBackdropCreation() {
    const observer = new MutationObserver(adjustModalBackgroundWidth);

    const targetNode = document.getElementById('no-jquery-ui');

    const config = { childList: true };

    if (targetNode) {
        observer.observe(targetNode, config);
    }
}
